module.exports = __webpack_public_path__ + "assets/media/evening.7adf1b9a.mp3";